"use client";

import { useState } from "react";
import { QueueMinusCircleIcon, QueuePlusCircleIcon } from "@/components/icons";

const howItWorksItems = [
  "Entre na fila virtual escaneando o QR Code da experiência dentro da Casa CazéTV.",
  "Acompanhe esta página para saber quando será sua vez de ir até a fila física. Quando chegar o momento, o aviso aparecerá por aqui.",
  "Após o chamado, você terá até 10 minutos para comparecer à fila física. Depois desse período, sua vaga será liberada para o próximo da fila.",
  "A participação é individual e intransferível.",
];

export function QueueVirtualHero() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <section className="w-full bg-[#fec822] text-black pt-3">
      <div className="mx-auto w-full max-w-[380px] px-5 pb-[22px] pt-[26px]">
        <h1 className="text-[22px] font-black uppercase leading-none text-[#2033ef]">
          Fila virtual
        </h1>
        <p className="mt-[18px] max-w-[280px] text-[15px] leading-[1.2]">
          Acompanhe sua posição na fila e saiba a hora certa de ir para a
          experiência.
        </p>

        <div className="mt-[26px] rounded-[21px] bg-[#2033ef] text-white">
          <button
            type="button"
            className="flex h-[41px] w-full items-center justify-between px-[20px] text-left text-[15px] font-bold text-white"
            aria-expanded={isOpen}
            onClick={() => setIsOpen((current) => !current)}
          >
            Veja como funciona
            <span className="relative h-[27px] w-[27px] shrink-0">
              <QueuePlusCircleIcon
                className={`absolute inset-0 h-full w-full transition-all duration-300 ease-out ${
                  isOpen
                    ? "rotate-90 scale-75 opacity-0"
                    : "rotate-0 scale-100 opacity-100"
                }`}
              />
              <QueueMinusCircleIcon
                className={`absolute inset-0 h-full w-full transition-all duration-300 ease-out ${
                  isOpen
                    ? "rotate-0 scale-100 opacity-100"
                    : "-rotate-90 scale-75 opacity-0"
                }`}
              />
            </span>
          </button>

          <div
            className={`grid transition-[grid-template-rows,opacity] duration-500 ease-in-out ${
              isOpen
                ? "grid-rows-[1fr] opacity-100"
                : "grid-rows-[0fr] opacity-0"
            }`}
          >
            <div className="min-h-0 overflow-hidden rounded-b-[21px]">
              <ul className="space-y-[18px] px-[26px] pb-[22px] pt-[8px] text-[14px] font-normal leading-[1.2]">
                {howItWorksItems.map((item) => (
                  <li key={item} className="flex gap-[11px]">
                    <span className="mt-[6px] h-[5px] w-[5px] shrink-0 rounded-full bg-white" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
